import {Record as record} from 'immutable';

export default record(
    {
        byOwnerProperties: [],
        byOwnerPropertiesFetchFailed: false,
        byOwnerPropertiesFetchSuccess: false,
        byOwnerClientRequestId: '',
        recommendedProperties: [],
        recommendedPropertiesAlternativeTitle: '',
        recommendedPropertiesFetchSuccess: false,
        recommendedPropertiesFetchFailed: false,
        inquiryProperties: [],
        inquiryPropertiesFetchSuccess: false,
        inquiryPropertiesFetchFailed: false,
        inquiryClientRequestId: '',
        propertyContentItems: [],
        unitContentItems: [],
        unitMetadata: [],
        urgencyMessages: {},
        rankedBadges: [],
        pricingBadges: [],
        superlativeBadges: [],
        geoRelativeDistances: null,
        description: null,
        localizedPropertyDescriptionMap: {},
        vtHelpfulnessHistory: {},
        webRatingBadges: []
    },
    'listingExtended'
);
